(function () {
  function initIcSlider(sectionId) {
    var root = document.getElementById(sectionId);
    if (!root || root.dataset.icInitialized) return;
    root.dataset.icInitialized = 'true';

    function pauseAllVideos() {
      var videos = root.querySelectorAll('.ic-slide-video');
      videos.forEach(function (v) {
        v.pause();
      });
    }

    function playActiveVideo(swiper) {
      pauseAllVideos();
      var activeSlide = swiper.slides[swiper.activeIndex];
      if (!activeSlide) return;
      var video = activeSlide.querySelector('.ic-slide-video');
      if (!video) return;
      var playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch(function () {
          // Autoplay blocked (e.g. mobile Safari without interaction) — leave paused,
          // the play button overlay lets the visitor start it manually.
        });
      }
    }

    var swiper = new Swiper(root, {
      slidesPerView: '1',
      centeredSlides: true,
      spaceBetween: 16,
      loop: true,
      pagination: {
        el: root.querySelector('.swiper-pagination'),
        clickable: true
      },
      breakpoints: {
        750: {
          slidesPerView: 'auto',
          spaceBetween: 24
        },
        1000: {
          slidesPerView: 'auto',
          spaceBetween: 45
        }
      },
      on: {
        init: function (sw) {
          playActiveVideo(sw);
        },
        slideChangeTransitionEnd: function (sw) {
          playActiveVideo(sw);
        }
      }
    });

    root.querySelectorAll('.ic-slide-play').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var media = btn.closest('.ic-slide-media');
        var video = media && media.querySelector('.ic-slide-video');
        if (!video) return;
        if (video.paused) {
          video.muted = false;
          video.play();
          btn.classList.add('is-playing');
        } else {
          video.pause();
          btn.classList.remove('is-playing');
        }
      });
    });

    root.querySelectorAll('.ic-slide-video').forEach(function (video) {
      video.addEventListener('pause', function () {
        var btn = video.parentElement.querySelector('.ic-slide-play');
        if (btn) btn.classList.remove('is-playing');
      });
      video.addEventListener('play', function () {
        var btn = video.parentElement.querySelector('.ic-slide-play');
        if (btn) btn.classList.add('is-playing');
      });
    });
  }

  window.initIcSlider = initIcSlider;
})();